<!-- Copyright 2020 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0
Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License. -->

import {Layout} from '@react-spectrum/docs';
export default Layout;

import docs from 'docs:@react-aria/aria-modal-polyfill';
import {HeaderInfo, FunctionAPI, TypeContext, InterfaceType} from '@react-spectrum/docs';
import packageData from '@react-aria/aria-modal-polyfill/package.json';

---
category: Overlays
keywords: [dialog, modal, aria]
---

# watchModals

<p>{docs.exports.watchModals.description}</p>

<HeaderInfo
  packageData={packageData}
  componentNames={['watchModals']} />

## Introduction

Certain browser + screen reader combinations do not implement aria-modal correctly, which may unintentionally allow users to navigate outside of the modal.
`react-aria-modal` watches a container element for `aria-modal` nodes and hides the rest of the dom from screen readers with `aria-hidden` when one is open. See the [aria-hidden](https://www.npmjs.com/package/aria-hidden) package for more details.
Most of the time you do not need this, it should only be necessary if your app is not mounted at the root of the page.

## API

<FunctionAPI function={docs.exports.watchModals} links={docs.links} />

## How to use
Include `@react-aria/aria-modal-polyfill` once in your application and call `watchModals` before any modals are rendered.
```
import {watchModals} from '@react-aria/aria-modal-polyfill';
watchModals();
```

By default, `@react-aria/aria-modal-polyfill` watches the document body, but you can also pass it a selector string if your modals are mounted in a different container.

```
watchModals('.my-modal-root');
```
